import { useCallback, useEffect, useRef, useState } from "react";

export function useToast(duration = 2400) {
  const [message, setMessage] = useState("");
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        window.clearTimeout(timerRef.current);
      }
    };
  }, []);

  const show = useCallback(
    (text: string) => {
      setMessage(text);
      if (timerRef.current) {
        window.clearTimeout(timerRef.current);
      }
      timerRef.current = window.setTimeout(() => {
        setMessage("");
      }, duration);
    },
    [duration],
  );

  return { message, show };
}

export function Toast({ message }: { message: string }) {
  if (!message) return null;

  return (
    <div className="animate-fade-in fixed bottom-24 left-1/2 z-[80] -translate-x-1/2 rounded-full border border-background-700/60 bg-foreground-950/95 px-5 py-2.5 text-sm text-background-50 md:bottom-10">
      <span className="flex items-center gap-2 whitespace-nowrap">
        <i className="ri-checkbox-circle-line text-accent-400"></i>
        {message}
      </span>
    </div>
  );
}

export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // 继续使用兜底方案
  }

  try {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "true");
    textarea.style.position = "fixed";
    textarea.style.top = "-1000px";
    document.body.appendChild(textarea);
    textarea.select();
    const result = document.execCommand("copy");
    document.body.removeChild(textarea);
    return result;
  } catch {
    return false;
  }
}